/*
 * @Author: Json Chen
 * @Date: 2021-06-23 09:34:07
 * @LastEditTime: 2021-06-24 13:05:31
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/LinkLibrary/Components/MiniForm.tsx
 */
import React from 'react';
import { Input, Form } from 'antd';

import styles from '../style.module.less';
import { replaceI18nVariables } from '@/src/tools/tools';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const MiniForm = () => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  return (
    <div className={styles.linkTypeMiniContent}>
      <Form.Item
        name={['appid']}
        label='AppID*'
        rules={[
          {
            required: true,
            pattern: /\S/,
            message: `${replaceI18nVariables(
              getI18n('general.fieldisrequired'),
              'AppID',
            )}`,
          },
        ]}>
        <Input size='large' maxLength={200} />
      </Form.Item>
      <Form.Item
        name={['path']}
        label={getI18n('storeLinkLibrary.detail.path')}
        rules={[{ required: false }]}>
        <Input
          size='large'
          placeholder={getI18n('storeLinkLibrary.detail.enterPath')}
          maxLength={500}
        />
      </Form.Item>
      <Form.Item
        name={['extra']}
        label={getI18n('storeLinkLibrary.detail.extraData')}
        rules={[{ required: false }]}>
        <Input size='large' maxLength={200} />
      </Form.Item>
    </div>
  );
};

export default MiniForm;
